import i18n, { type BackendModule } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { en } from "./locales/en";

export const languages = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
  { code: "it", label: "Italiano" },
  { code: "fr", label: "Français" },
] as const;

export type LanguageCode = (typeof languages)[number]["code"];

// English ships in the main bundle as the fallback, the other locales are
// split into their own chunks and only fetched when selected
const lazyLocales = import.meta.glob<Record<string, unknown>>(
  ["./locales/*.ts", "!./locales/en.ts"],
  { import: "default" },
);

const lazyLocaleBackend: BackendModule = {
  type: "backend",
  init() {},
  read(language, _namespace, callback) {
    const load = lazyLocales[`./locales/${language}.ts`];
    if (!load) {
      callback(new Error(`no translations for language "${language}"`), false);
      return;
    }

    load().then(
      (resources) => callback(null, resources),
      (err) => callback(err, false),
    );
  },
};

i18n.on("languageChanged", (language) => {
  document.documentElement.lang = language;
});

i18n
  .use(lazyLocaleBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en } },
    partialBundledLanguages: true,
    fallbackLng: "en",
    supportedLngs: languages.map((language) => language.code),
    load: "languageOnly",
    interpolation: {
      // React already escapes rendered strings
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "inventoree-language",
      caches: ["localStorage"],
    },
  });

export default i18n;
